import { IndustryItem } from './IndustryItem/types';

export const IndustriesData: IndustryItem[] = [
  {
    id: 1,
    title: 'Real Estate Agents',
    subTitle: 'Hyper-Local branded real estate videos',
    icon: 'home-05',
    link: '',
  },
  {
    id: 2,
    title: 'Mortgage Brokers',
    subTitle: 'Mange social media with compliance',
    icon: 'coins-hand',
    link: '',
  },
  {
    id: 3,
    title: 'Financial Advisors',
    subTitle: 'Stay top-of-mind with financial videos',
    icon: 'currency-dollar',
    link: '',
  },
];
